import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { VendorEleFileConfigFieldEnum as Fields } from 'Common/FieldEnum';

import ElectronicFileConfigFields from './ElectronicFileConfigFields';
import { VENDOR_ELECTRONIC_FILE_CONFIG_NAME } from 'Common/FormEnum';
import { actions } from '../state/actions';

class ElectronicFileConfigForm extends Component {
  render() {
    const {
      onSubmit,
      fileFormat,
      fileFields,
      customerInfo,
      configData,
    } = this.props;

    return (
      <Form onSubmit={onSubmit}>
        <Field name={Fields.Id} component="input" type="hidden" />
        <ElectronicFileConfigFields
          configData={configData}
          fileFormat={fileFormat}
          fileFields={fileFields}
          customerInfo={customerInfo}
        />
      </Form>
    );
  }
}
ElectronicFileConfigForm = connect(
  null,
  ...actions
)(ElectronicFileConfigForm);

export default reduxForm({
  form: VENDOR_ELECTRONIC_FILE_CONFIG_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
})(ElectronicFileConfigForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/ElectronicFileConfigForm.js